import { useNavigation } from "./helpers/navigationHelpers";
import { AboutUsPage } from "./website/pages/AboutUsPage";
import { DisclaimerPage } from "./website/pages/disclaimer";
import { FAQPage } from "./website/pages/faq";
import { ActiveWebsitePage } from "./types/ActiveWebsitePageEnum";
import { NotFound } from "./shared/components/notFound/NotFound";
import { HomePage } from "./website/home";
// import { Unauthorized } from "./components/Unauthorized/Unauthorized";
// import { InternalServerError } from "./components/InternalServerError/InternalServerError";

export const App = () => {
  const { activePage, navigateToPage } = useNavigation();

  const renderContent = () => {
    switch (activePage) {
      case ActiveWebsitePage.Home:
        return <HomePage />;
      case ActiveWebsitePage.FAQ:
        return <FAQPage />;
      case ActiveWebsitePage.AboutUs:
        return <AboutUsPage />;
      case ActiveWebsitePage.Disclaimer:
        return <DisclaimerPage returnToHomePage={() => navigateToPage(ActiveWebsitePage.Home)} />;
      default:
        return <NotFound returnToHomePage={() => navigateToPage(ActiveWebsitePage.Home)} />;
      // return <InternalServerError />;
      // return <Unauthorized />;
    }
  };

  return <>{renderContent()}</>;
};
